import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Selector, SelectorUpdate } from "@/model";
import selectorRepository from "@/repository/selectorRepository";
import { selectorQueryKeys } from "./keys";


export const useUpdateSelector = (agentId: number, selectorId?: string) => {
    const queryClient = useQueryClient();

    return useMutation<Selector, AxiosError, SelectorUpdate>({
        mutationKey: ["selector", "agent", agentId, "selector", selectorId, "update"],
        mutationFn: async (body: SelectorUpdate) => {
            try {
                const { data } = await selectorRepository.update(agentId, selectorId!, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                exact: false
            });
        }
    });
};
